import colors from '../TCP/colors';
import purple from '../colors/purple';

const snjColors = {
  ...colors,
  PRIMARY_BUTTON_BORDER_COLOR: purple[900],
  PRIMARY_BUTTON_COLOR: purple[300],
  PRIMARY_TEXT_COLOR: '#000000',
  NOTIFICATION_PROMPT_WRAPPER: '#ffffff',
  ITEM_COUNT_WRAPPER: purple[300],
  TAP_TO_JOIN_BG_COLOR: purple[300],
  PLP_SIDEBAR_SUBCATEGORY_BORDER: purple[800],
  PLP_SIDE_NAVBAR_SUBHEADER_BORDER: purple[800],
};

export default snjColors;
